// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root___PC6Y","notes":"Notes_notes__3ulDI","note":"Notes_note__3nTqL","markdown":"Notes_markdown__3HpHB"};